export const passwordReset = "password/reset";
